import React, { FC } from 'react';
import { Text, Icon } from '@cubeyou-team/hx-react-components';

import { HomeProduct } from '../../api/request';

const PRODUCT_IMAGE_BASE_URL = 'https://cdn.helixa.ai/images/home';

interface ProductTileProps {
  item: HomeProduct;
}

export const ProductTile: FC<ProductTileProps> = ({ item }) => (
  <>
    <div
      className="h-52 w-full bg-center bg-cover"
      style={{
        backgroundImage: `url('${PRODUCT_IMAGE_BASE_URL}/${item.slug}.png')`,
      }}
    />
    <div className="p-8">
      <div className="flex items-center justify-between gap-2">
        <Text tag="h3" size="body" weight="bold">
          {item.name}
        </Text>
        <Icon size="medium" icon="arrow-right" variant="primary" />
      </div>
    </div>
    <div className="px-8 pb-8">
      <Text size="xbody" variant="dark_lighter">
        {item.description}
      </Text>
    </div>
  </>
);
